import { Component, computed, effect, inject, input, InputSignal, output, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { Psychologist } from '../../models/psychologists';
import { LogService } from '../../services/log.service';
import { Log } from '../../models/log';
import { TranslatePipe } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import TYPES from '../../constants/types';

@Component({
  selector: 'app-users-sharing-logs',
  imports: [
    TranslatePipe,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule
  ],
  templateUrl: './users-sharing-logs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './users-sharing-logs.component.scss'
})
export class UsersSharingLogsComponent {

  psychologist: InputSignal<Psychologist | undefined> = input();
  filterBy : InputSignal<string> = input('');
  userSelected = output<string>(); 
  
  logService: LogService<Log> = inject(LogService);
  
  listNames: WritableSignal<any[]> = signal([]);

  usersShared = computed(() => {
    const users:any[] = [];
    for(const item of this.listNames()){
      if(!users.some( (user) => user.id === item.users.id )){
        users.push({
        id: item.users.id,
        first_name: item.users.first_name,
        last_name: item.users.last_name
      });
      }
    }
    return users;
  });

  PLANS: any;

  userFilter: UntypedFormControl;

  constructor(){
    this.PLANS = TYPES.DATABASE.PLANS;

    effect(() =>{
      if(this.psychologist()){
        this.loadUserNamesSharingLogs();
      }

      if(this.filterBy()){
        this.userFilter.patchValue(this.filterBy());
      }
    });

    this.userFilter = new UntypedFormControl(this.filterBy());
  }

  loadUserNamesSharingLogs(){
    if(this.psychologist()){
      const psychologistId = this.psychologist()?.id;
      
      if(this.psychologist()?.subscription_plan === this.PLANS.STARTER.code){
        if(psychologistId){
          this.logService.getUsersNameSharingLogsByPsychologistIdForStarterPlan(psychologistId).then(
            (data) => {
              this.listNames.set(data.reverse());
            }
          );
        }
      }else{
        if(psychologistId){
          this.logService.getUsersNameSharingLogsByPsychologistId(psychologistId).then(
            (data) => {
              this.listNames.set(data);
            }
          );
        }
      }      
    }
  }

  filterByUser(userId:any){
    this.userSelected.emit(userId.value);
  }

}
